import { defineNuxtPlugin } from '#app';
import VuePhaserPlugin from './vue.index';
export default defineNuxtPlugin(function (nuxtApp) {
    nuxtApp.vueApp.use(VuePhaserPlugin);
});
